import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureGrid from './components/FeatureGrid';
import AboutSection from './components/AboutSection';
import { SafetySection, FinalCtaSection } from './components/CtaSection';
import ArticleCards from './components/ArticleCards';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeatureGrid />
        <AboutSection />
        <SafetySection />
        <ArticleCards />
        <FinalCtaSection />
      </main>
      <Footer />
    </div>
  );
}